import CheckBox from "../../main/CheckBox.tsx";

interface ReminderConsentToggleProps {
  label: string;
  value: boolean | null;
  onChange: (value: boolean | null) => void;
  id: string;
}

const ReminderConsentToggle = (props: ReminderConsentToggleProps) => {
  const labelClassName = props.value === null ? "text-red-600" : undefined;

  return (
    <div className="flex items-center justify-between gap-2">
      <span className={labelClassName}>{props.label}</span>
      <div className="flex items-center gap-4">
        <CheckBox
          checked={props.value === true}
          onChange={(checked) => props.onChange(checked ? true : null)}
          label="Oui"
          id={`${props.id}_yes`}
          className={labelClassName}
        />
        <CheckBox
          checked={props.value === false}
          onChange={(checked) => props.onChange(checked ? false : null)}
          label="Non"
          id={`${props.id}_no`}
          className={labelClassName}
        />
      </div>
    </div>
  );
};

export default ReminderConsentToggle;
